import React, { useEffect, useState } from "react";
import { Col, Row, Button } from 'antd';
import { MdOutlinePublic, MdOutlineSearch, MdOutlineLocationOn, MdOutlinePeopleAlt } from "react-icons/md";
import { setLocalStorage, getLocalStorage } from '../../utils/func';
import { useNavigate } from 'react-router-dom';
import config from '../../utils/config';
import { APP_ROUTES } from '../../utils/constant';
import url from '../../utils/url';

const PostFilter = () => {
	const [area, setArea] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		let areaLocalStorage = getLocalStorage(config.area);
		if (areaLocalStorage===null || areaLocalStorage==='null') {
			console.log("AREA");
			console.log(areaLocalStorage);
			areaLocalStorage = config.areaType.all;
			setLocalStorage(config.area, areaLocalStorage);
		}
		setArea(areaLocalStorage);
	}, []);

	const changeArea = (areaType) => {
		setLocalStorage(config.area, areaType);
		setArea(areaType);
		navigate(url(APP_ROUTES.MAIN));
		window.location.reload();
	}

	return (
		<div className="wiwHeader">
			<Row gutter={8}>
				<Col className="align-center" span={6}>
					<Button icon={<MdOutlineSearch />} />
				</Col>
				<Col className="align-center" span={6}>
					<Button 
						onClick={() => changeArea(config.areaType.all)}
						className={(area === config.areaType.all) ? "active-btn" : ""}
						icon={<MdOutlinePublic />} />
				</Col>
				<Col className="align-center" span={6}>
					<Button 
						onClick={() => changeArea(config.areaType.country)} 
						className={(area === config.areaType.country) ? "active-btn" : ""}
						icon={<MdOutlineLocationOn />} />
				</Col>
				<Col className="align-center" span={6}>
					<Button 
						onClick={() => changeArea(config.areaType.friends)} 
						className={(area === config.areaType.friends) ? "active-btn" : ""}
						icon={<MdOutlinePeopleAlt />} />
				</Col>
			</Row>
		</div>
	)
}

export default PostFilter;